<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <PmAlarmQueryLeftTree ref="PmAlarmQueryLeftTree" @nodeSelectedOfPmAlarmQueryTree="nodeSelectedOfPmAlarmQueryTree"></PmAlarmQueryLeftTree>
    </template>
    <template v-slot:right_view>
      <PmAlarmQueryRightList ref="PmAlarmQueryRightList" :paramsOfListQuery="paramsOfListQuery"></PmAlarmQueryRightList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../layouts/BasicLayout';
  import PmAlarmQueryLeftTree from "../../../components/pmConfig/pproject/PmAlarmManagementForP/Left/PmAlarmQueryLeftTree";
  import PmAlarmQueryRightList from "../../../components/pmConfig/pproject/PmAlarmManagementForP/Right/PmAlarmQueryRightList";

  export default {
    name: 'PmAlarmQuery',
    components: {
      BasicLayout,
      PmAlarmQueryLeftTree,
      PmAlarmQueryRightList
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('Pm.pmAlarmManagement')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.pmAlarmManagement')}`
        },
        paramsOfListQuery: {}
      };
    },
    methods: {
      nodeSelectedOfPmAlarmQueryTree(node){
        let params = {
          neId: '',
          neTypeCode: '',
          neVersion: '',
          alarmType: null
        }
        if(node.nodeData.parentID == 'root'){
          params.neTypeCode = node.nodeData.id.split('_')[1];
          params.neVersion = node.nodeData.id.split('_')[2];
        }else if (node.nodeData.hasChildren == false){
          params.neId = node.nodeData.id;
          params.neTypeCode = node.nodeData.parentID.split('_')[1];
          params.neVersion = node.nodeData.parentID.split('_')[2];
        }
        this.$refs.PmAlarmQueryRightList.getPmAlarmInfoListByCondition(params,'change');
        this.paramsOfListQuery = params;
        this.$refs.PmAlarmQueryRightList.alarmType = 0;
      }
    },
  };
</script>

<style>

</style>
